import { Component, Input, ViewChild } from '@angular/core';
import { provideTranslocoScope } from '@ngneat/transloco';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Observable, delay, tap } from 'rxjs';
import { TooltipDirective } from '../../tooltip';
import { UI_TOOLS_TRANSLOCO_SCOPE } from '../../ui-tools-transloco-scope';
import { ClipboardService } from '../clipboard.service';

@UntilDestroy()
@Component({
  selector: 'yat-copy-to-clipboard',
  templateUrl: './copy-to-clipboard.component.html',
  styleUrls: ['./copy-to-clipboard.component.scss'],
  providers: [provideTranslocoScope(UI_TOOLS_TRANSLOCO_SCOPE)]
})
export class CopyToClipboardComponent {
  constructor(private clipboardService: ClipboardService) {}

  @ViewChild(TooltipDirective)
  tooltip: TooltipDirective;

  @Input()
  id: string;

  @Input()
  content: string | undefined = undefined;

  isCopying: boolean = false;

  readonly tooltipText: Observable<string> = this.clipboardService.getClipboardCopiedText();

  copyToClipboard(): void {
    if (this.content) {
      this.clipboardService
        .copyToClipboard(this.content)
        .pipe(
          tap(() => this.tooltip.open()),
          tap(() => (this.isCopying = true)),
          delay(this.clipboardService.getTooltipDelay()),
          tap(() => this.tooltip.close()),
          tap(() => (this.isCopying = false)),
          untilDestroyed(this)
        )
        .subscribe();
    }
  }
}
